/** Index of `key` among the tabs `b-tabs` actually renders, or -1. */
export function findTabIndexByKey(tabs, key) {
  return tabs.findIndex((tab) => tab.key === key);
}
